export default "__VITE_ASSET__zgTpISDZ__"